import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CarouselMonitorInterceptor implements HttpInterceptor {
  private carouselCallCount = 0;
  private lastCallTime = 0;
  private readonly WARNING_THRESHOLD = 5; // Advertencia después de 5 llamadas
  private readonly TIME_WINDOW = 60000; // 1 minuto

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo monitorear llamadas al carrusel
    if (request.url.includes('carrusel')) {
      const now = Date.now();

      // Reiniciar contador si ha pasado más de 1 minuto
      if (now - this.lastCallTime > this.TIME_WINDOW) {
        this.carouselCallCount = 0;
      }

      this.carouselCallCount++;
      this.lastCallTime = now;

      // Advertencia si hay muchas llamadas
      if (this.carouselCallCount > this.WARNING_THRESHOLD) {
        console.warn(`⚠️ Carrusel API: ${this.carouselCallCount} llamadas en el último minuto. Posible problema de rendimiento.`);
      }

      console.log(`🔄 Carrusel API call #${this.carouselCallCount}: ${request.url}`);
    }

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (request.url.includes('carrusel')) {
            console.log(`✅ Carrusel API response received`);
          }
        },
        error: (error) => {
          if (request.url.includes('carrusel')) {
            console.error(`❌ Carrusel API error:`, error);
          }
        }
      })
    );
  }
}
